export const supportingPaneDefaultSize = 40;

export const resolveSupportingPaneDefaultSize = (args: {
  supportingPaneOpen: boolean;
  supportingPanelMinSize: number | undefined;
  supportingPanelMaxSize: number | undefined;
}): number => {
  if (args.supportingPanelMinSize != null) {
    return args.supportingPanelMinSize;
  }

  if (args.supportingPanelMaxSize === undefined) {
    return supportingPaneDefaultSize;
  }

  if (supportingPaneDefaultSize <= args.supportingPanelMaxSize) {
    return supportingPaneDefaultSize;
  }

  return args.supportingPanelMaxSize;
};
